import BaseService from "services/BaseService";

class MasterImageService extends BaseService {
  upload = async (formData) => {
    return await this._api.post("master/image/upload", formData);
  };

  uploadLogo = async (formData) => {
    return await this._api.post("master/logo/upload", formData);
  };

  list = async (folder) => {
    return await this._api.post("master/image/list", { folder });
  };

  delete = async (id) => {
    return await this._api.post("master/image/delete", { id });
  };

  deleteList = async (ids) => {
    return await this._api.post("master/image/delete_list", { ids });
  };

  moveList = async (ids, folder_id) => {
    return await this._api.post("master/image/move_list", { ids, folder_id });
  };
}

export default MasterImageService;
